function contact({ id, name, phone, type, whatsapp, image }) {
    return {
        id, name, phone, type, whatsapp, image
    }
}

export default contact